import React from 'react';
import ImageTextSection from './ImageTextSection';

// You can import these sections into your App.js
const AboutSections = () => {
    return (
        <>
            {/* Section 1: Umfassende Fahrzeugoptimierung */}
            <ImageTextSection
                title="Umfassende Fahrzeugoptimierung"
                content={[
                    "Wir optimieren nicht nur PKW, Motorräder, LKW und Busse, sondern auch Wohnmobile, Traktoren, Landmaschinen und Bootsmotoren. Chiptuning Pforzheim steigert nicht nur Ihren Fahrspaß durch bessere Beschleunigung und Durchzug, sondern lohnt sich auch der Umwelt zuliebe, die durch einen geringeren Verbrauch erheblich geschont wird.",
                    "Insgesamt kann man sagen, dass der Leistungszuwachs durch Chiptuning Stuttgart bei Turbo-Dieselfahrzeugen um bis zu 35% und bei Benzinfahrzeugen mit Turbolader um bis 45% gesteigert werden kann."
                ]}
                imageSrc="https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=800&q=80"
                imageAlt="Luxury car interior"
                imageOnRight={false}
            />

            {/* Section 2: Individuelle Programmierung */}
            <ImageTextSection
                title="Individuelle Programmierung"
                content="Bei Diesel- und Benzinfahrzeugen ohne Turbolader gibt es eine Leistungsoptimierung um bis zu 15%. Jede Leistungssteigerung an einem Motorsteuergerät wird von uns als Tuning Werkstatt Stuttgart jeweils einzeln neu programmiert."
                imageSrc="https://images.unsplash.com/photo-1555215695-3004980ad54e?w=800&q=80"
                imageAlt="BMW on the road"
                imageOnRight={true}
            />
        </>
    );
};

export default AboutSections;